import { useMemo } from "react";
import { Card, CardBody, CardTitle } from "reactstrap";
import  BarChart  from "./ApexChart/BarChart";

const CompletionWidget = ({ data = {}, t, isFetching }) => {
  const normalizedData = Array.isArray(data) ? data[0] || {} : data;

  const averagePercent = Number(normalizedData?.average_percent || 0);

  const chartData = useMemo(() => {
    return (normalizedData?.by_tom || [])
      .sort((a, b) => a.completion_percent - b.completion_percent)
      .slice(0, 10)
      .reduce((acc, item) => {
        acc[`TOM ${item.tom_id}`] = Number(item.completion_percent || 0);
        return acc;
      }, {});
  }, [normalizedData]);

  if (isFetching) {
    return (
      <div
        className="dt-field dt-skeleton"
        style={{ width: "100%", height: "340px" }}
      />
    );
  }

  return (
    <Card className="card_box_Shadow h-100">
      <CardBody>
        <div className="mb-4">
          <CardTitle>{t("Completion")}</CardTitle>
          <p className="mb-0 text-muted">
            {t("Average Completion")}: <strong>{averagePercent}%</strong>
          </p>
        </div>

        {Object.keys(chartData).length === 0 ? (
          <p className="text-muted mb-0">{t("No records found.")}</p>
        ) : (
          <BarChart
            title="Lowest Completion TOMs"
            data={chartData}
            withoutCard={true}
          />
        )}
      </CardBody>
    </Card>
  );
};

export default CompletionWidget;
